<h1 mat-dialog-title class="mat-typography">
  {{data.title}}
</h1>

<div mat-dialog-content class="mat-typography">
  <div [innerHtml]="data.message">
  </div>

  <div *ngIf="data.hasInput" class="marginTop">
    <div [innerHtml]="data.inputMessage">
    </div>

    <form class="marginTop">
      <mat-form-field>
        <input matInput
          placeholder="{{data.inputPlaceholder}}"
          [(ngModel)]="data.inputValue"
          [ngModelOptions]="{standalone: true}">
      </mat-form-field>
    </form>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>
    Cancel
  </button>

  <button mat-raised-button color="warn"
    [disabled]="data.hasInput && data.inputValue !== data.inputTarget"
    [mat-dialog-close]="true">
    {{data.buttonText}}
  </button>
</div>
